import { X } from "lucide-react";

export default function VideoModal({ episode, onClose }) {
  if (!episode) return null;
  return (
    <div
      className="fixed inset-0 z-[100] bg-black/95 backdrop-blur-md flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="video-modal"
    >
      <button
        onClick={onClose}
        className="absolute top-6 right-6 text-white hover:text-svn-red"
        aria-label="Close"
        data-testid="video-modal-close"
      >
        <X size={32} />
      </button>
      <div
        className="w-full max-w-5xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="aspect-video bg-black border border-white/10">
          {episode.youtube_id ? (
            <iframe
              className="w-full h-full"
              src={`https://www.youtube.com/embed/${episode.youtube_id}?autoplay=1`}
              title={episode.title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-neutral-400">
              Video unavailable
            </div>
          )}
        </div>
        <div className="mt-4 text-white">
          <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-gold">
            {episode.show_slug?.replace(/-/g, " ")}
          </p>
          <h3 className="font-display text-2xl md:text-3xl font-bold mt-1">
            {episode.title}
          </h3>
          {episode.description && (
            <p className="mt-2 text-neutral-300 max-w-3xl">{episode.description}</p>
          )}
        </div>
      </div>
    </div>
  );
}
